if(typeof Plugin_PlatebniPoukazy === 'undefined') {

    var Plugin_PlatebniPoukazy = {

        init: function () {
            $(document)
                .on('modal.button.miniform.close.pre', function (e) {

                    e.preventDefault();

                    // odeslání platebních poukazů
                    var panel = $('#modal-send-payment-tickets');
                    if (panel.length) {

                        var url = window.location.protocol + '//' + window.location.host;
                        url += '/plugin/PluginPlatebniPoukazy/ajaxSendTickets';
                        var idSection = $('#idSection').val();
                        var idItem = $('#idItem').val();
                        if(idSection.length) {
                            url += '/' + idSection;
                            if(idItem.length) {
                                url += '/' + idItem;
                            }
                        }

                        // memcache hash
                        var ch = $('#_ch');
                        if(ch.length) {
                            url += '?_ch=' + ch.val();
                        }

                        var grid = $('#grid_section_i102_i6');
                        var rows = $(grid).jqGrid('getGridParam', 'selarrrow');
                        var idsSelected = [];
                        $.each(rows, function (i, id) {
                            var dataId = $(grid).jqGrid('getCell', id, 'grid_dataid');
                            if(dataId.length) {
                                idsSelected.push(dataId);
                            }
                        });

                        $.ajax({
                            type: 'post',
                            url: url,
                            dataType: "json",
                            data: {'paymentDate': $('#modal-datumsplatnosti').val(), 'tickets': $('#vyberpoukazu').val(), 'description': $('#modal-popis').val(), 'rowsSelected': idsSelected},
                            global: true,
                            beforeSend: function () {
                                Lemo_Alert.addInfo('Odesílám platební poukazy', 'SendTicketsBeforeSend');
                            },
                            complete: function () {
                                Lemo_Alert.closeById('SendTicketsBeforeSend');
                            },
                            success: function (r) {
                                grid.trigger("reloadGrid");
                                if(r.hasOwnProperty('status') && true === r.status) {

                                }
                                if (r.hasOwnProperty('messages')) {
                                    Lemo_Alert.addMany(r.messages);
                                }
                            },
                            error: function () {
                                Lemo_Alert.addDanger('Odeslání platebních poukazů selhalo ...', 'SendTicketsError');
                            }
                        });

                    }
                });
        }
    };
}

$(document)
    .ready(function() {
        Plugin_PlatebniPoukazy.init();
    });


